module.exports = __webpack_public_path__ + "static/media/pass-02.60188829.svg";